module.exports = __webpack_public_path__ + "static/media/29FUNOV16.a23ed0ab.jpg";